import type { FileItem } from '../../models';

export function buildDragImage(files: FileItem[]): HTMLElement {
  const wrap = document.createElement('div');
  wrap.className = 'right-panel__drag-image';

  const iconContainer = document.createElement('div');
  iconContainer.className = 'right-panel__drag-image-icon-container';

  const icon = document.createElement('i');
  icon.className = files.some((f) => f.type === 'folder') ? 'pi pi-folder' : 'pi pi-file';
  iconContainer.appendChild(icon);

  if (files.length > 1) {
    const badge = document.createElement('div');
    badge.className = 'right-panel__drag-image-badge';
    badge.textContent = files.length.toString();
    iconContainer.appendChild(badge);
  }

  wrap.appendChild(iconContainer);

  if (files.length === 1) {
    const label = document.createElement('div');
    label.className = 'right-panel__drag-image-label';
    label.textContent = files[0].name;
    wrap.appendChild(label);
  }

  return wrap;
}
